import React from 'react'
import './nav.css'
import Logo from '../../assets/kyriosLogo.png'

const Nav = () => {  
  return (
    <nav>
      <div className="brand"><a href="#header" target='_blank' rel="noreferrer"><img src={Logo} alt="LOGO" /></a></div>


      <div className="nav__menu">
        
        <a href="#catalogo">CATALOGO</a>
        <a href="#contact">CONTACTO</a>
        <a href="#about">NOSOTROS</a>
      </div>
      
      
    </nav>
  )
}

export default Nav